<template>
    <div>
        <NavBar></NavBar>
        <h3 class="my-3 mx-auto">Lámina metálica en formato completo</h3>
        <p>En este apartado prodrá cotizar unicamente tramos completos de lámina metálica, sin incluir ningún
            tipo de
            servicio.</p>
        <CompSectionSheet @sendKiloPrice="getKiloPrice" @sendPriceConstant="getPriceConstant"
            @sendCommercialMm="getCommercialMm" @sendWeight="getWeigth" @sendDimensions="getDimensions">
        </CompSectionSheet>
        <CompSectionPrice :getKiloPrice="kiloPrice" :getWeightUnit="weigth" :getPriceConstant="priceConstant"
            :getCommercialMm="commercialMm" :getWidthValue="width" :getLengthValue="length"></CompSectionPrice>
    </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
import CompSectionSheet from "@/components/CompleteSectionQuote/CompSectionSheetComponent.vue";
import CompSectionPrice from "@/components/CompleteSectionQuote/CompSectionPriceSheetComponent.vue";
export default {
    name: "CompleteSectionView",
    data() {
        return {
            kiloPrice: 0,
            priceConstant: 0,
            commercialMm: 0,
            weigth: 0,
            length: 0,
            width: 0,
        };
    },
    methods: {
        getKiloPrice(data) {
            this.kiloPrice = data;
            // console.log("Desde el padre kiloPrice", this.kiloPrice);
        },
        getPriceConstant(data) {
            this.priceConstant = data;
            // console.log("Desde el padre ConstantPrice", this.priceConstant);
        },
        getCommercialMm(data) {
            this.commercialMm = data;
            // console.log("Desde el padre commercialMm", this.commercialMm);
        },
        getWeigth(data) {
            this.weigth = data;
            // console.log("Desde el padre weigth", this.weigth);
        },
        getDimensions(data) {
            this.width = data.width;
            this.length = data.length;
            // console.log("Desdde el padre width", this.width);
            // console.log("Desdde el padre length", this.length);
        }
    },
    components: {
        NavBar,
        CompSectionSheet,
        CompSectionPrice,
    },
};
</script>